import React, { useContext, useEffect, useState } from "react"
import { IconButton, Dialog, DialogTitle, Slide, DialogContent, Tabs, Tab, Paper } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import ChatRoot from "./ChatRoot"
import BookActions from "./BookActions"
import BookInformation from "./BookInformation"
import { getUnreadMessages } from "../../../functions/readMessagesFunctions"
import StateContext from "../../../context/StateContext"

const mobileTabsSx = { minHeight: 0, height: 40 }

const mobileTabSx = {
  p: 0,
  fontSize: 12,
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const BookDialog = ({ handleClose, book, isMobile }) => {
  const { ledgerList } = useContext(StateContext)
  const [currentTab, setCurrentTab] = useState(1)

  const bookInLedger = ledgerList.find((e) => e.bookId === book.id)
  const unreadMessages = getUnreadMessages(bookInLedger)

  useEffect(() => {
    if (unreadMessages) {
      setCurrentTab(2)
    }
  }, [unreadMessages])

  const open = !!book
  if (!open) {
    return null
  }

  const { title } = book

  const getChatLabel = () => {
    if (isMobile) return "Chat"

    if (bookInLedger) {
      return bookInLedger.action === "buy" ? "Chat mit Verkäufer" : "Chat mit Käufer"
    }

    return "Chat"
  }

  return (
    <Dialog
      sx={{
        height: isMobile ? "95dvh" : "85vh",
        "& .MuiDialog-paper": {
          height: isMobile ? "95dvh" : "85vh",
        },
      }}
      TransitionComponent={Transition}
      onClose={handleClose}
      open={open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle fontSize={isMobile ? 16 : null} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 0 }}>
        {title}
        <IconButton size={isMobile ? "small" : "medium"} onClick={handleClose}>
          <CloseIcon fontSize={isMobile ? "small" : "medium"} color="secondary" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
        }}>
        <Tabs variant="fullWidth" sx={isMobile && mobileTabsSx} value={currentTab} onChange={(_, v) => setCurrentTab(v)}>
          <Tab sx={isMobile && mobileTabSx} label={isMobile ? "Info" : "Information"} value={1} />
          <Tab sx={isMobile && mobileTabSx} label="Aktionen" value={3} />
          <Tab sx={isMobile && mobileTabSx} label={getChatLabel()} value={2} />
        </Tabs>

        <Paper
          elevation={currentTab === 1 ? 0 : 2}
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            borderRadius: 2,
            overflow: "hidden",
          }}>
          {currentTab === 1 && <BookInformation bookInLedger={bookInLedger} book={book} isMobile={isMobile} />}
          {currentTab === 2 && <ChatRoot currentChat={bookInLedger} />}
          {currentTab === 3 && <BookActions setCurrentTab={setCurrentTab} bookInLedger={bookInLedger} book={book} isMobile={isMobile} />}
        </Paper>
      </DialogContent>
    </Dialog>
  )
}

export default BookDialog
